import { Button } from '@southfields-digital/mpxlive-components';

import styles from './MatchStats.module.scss';

export type StatRowItem = {
  label: string;
  homeValue: string;
  awayValue: string;
};

type StatRowProps = {
  onClickImport?: (value: string) => void;
  children?: React.ReactNode;
} & StatRowItem;

export default function StatRow({
  label,
  homeValue,
  awayValue,
  onClickImport,
  children,
}: StatRowProps) {
  const valueHome = homeValue ?? 0;
  const valueAway = awayValue ?? 0;

  if (!valueHome && !valueAway) return null;
  return (
    <div className={styles.RowContainer}>
      <div className={styles.RowLabel}>{label}</div>
      <div>{valueHome}</div>
      <div>{valueAway}</div>
      {onClickImport && (
        <div>
          <Button
            onClick={() => onClickImport(`${valueHome} - ${valueAway}`)}
            variant="tertiary"
            iconProps={{ icon: 'copy', size: 16, color: '#5B5D70' }}
          />
        </div>
      )}
      {children}
    </div>
  );
}
